import React, { useCallback, useState } from 'react';
import DatePicker from 'react-datepicker';
import { addDays, getDay, setMinutes, setHours } from 'date-fns';
import PropTypes from 'prop-types';
import { DatePickerWrapper } from './DatePicker.styled';
import { BaseError } from 'components/common/BaseError';

const Picker = ({ id, value, setDateData }) => {
  const [err, setErr] = useState('');

  const onChange = useCallback(
    (date) => {
      setDateData((prev) => {
        if (
          Object.values(prev)
            .map((item) => item && item.getTime())
            .includes(date.getTime()) &&
          prev[id].getTime() !== date.getTime()
        ) {
          setErr('The Dates shold be different');
          return {
            ...prev,
            [id]: null,
          };
        } else {
          setErr('');
          if (date.getHours() === 0) {
            return {
              ...prev,
              [id]: setHours(date, 7),
            };
          }
          return {
            ...prev,
            [id]: date,
          };
        }
      });
    },
    [id, setDateData]
  );

  const isWeekday = useCallback((date) => {
    const day = getDay(date);
    return day !== 0 && day !== 6;
  }, []);

  const filterPassedTime = useCallback((time) => {
    const currentDate = setHours(setMinutes(new Date(), 0), 24);
    const selectedDate = new Date(time);
    return currentDate.getTime() < selectedDate.getTime();
  }, []);

  return (
    <DatePickerWrapper>
      <DatePicker
        selected={value}
        onChange={onChange}
        placeholderText='mm/dd/yyyy, hh:mm'
        dateFormat='MM/dd/yyyy,  hh:mm aa'
        showTimeSelect
        timeFormat='p'
        timeIntervals={15}
        fixedHeight
        filterDate={isWeekday}
        filterTime={filterPassedTime}
        excludeDates={[
          addDays(new Date(), 0),
          addDays(new Date(), 1),
          addDays(new Date(), 2),
          addDays(new Date(), 3),
        ]}
        minTime={setHours(setMinutes(new Date(), 0), 7)}
        maxTime={setHours(setMinutes(new Date(), 0), 16)}
        minDate={new Date()}
        onChangeRaw={(e) => e.preventDefault()}
      />
      {err && <BaseError>{err}</BaseError>}
    </DatePickerWrapper>
  );
};

Picker.propTypes = {
  id: PropTypes.string,
  setDateData: PropTypes.func,
  value: PropTypes.object,
};

export default React.memo(Picker);
